export default __webpack_public_path__ + "static/media/pro1m.c07adb89.png";